import { Messages } from '../../../codegen/Localize';
import { Order } from '../../../ts/helpers/Order';
import { OrderKeys } from '../../../ts/models/OrderKeys';
import { SortOptions } from '../../../ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '../../../ts/models/sort/SortOptionDefinitions';

export const metricsSortOptions: OptionsDictionary = {
  'name': SortOptions.name,
  /*
  'connectedViewName': {
    id: 'connectedViewName',
    getMenuItemDisplayValue: Messages.metricConnectedView,
    subSortOptions: {
      'asc': {
        id: 'connectedViewName.asc',
        field: OrderKeys.connectedViewName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByConnectedViewAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.connectedViewName)]
      },
      'desc': {
        id: 'connectedViewName.desc',
        field: OrderKeys.connectedViewName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByConnectedViewDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.connectedViewName)]
      }
    }
  },
  */
  'containerName': SortOptions.containerName,
  'owner': {
    id: 'owner',
    getMenuItemDisplayValue: Messages.column_owner,
    subSortOptions: {
      'asc': {
        id: 'owner.asc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByAZ,
        getButtonDisplayValue: Messages.sortByOwnerAsc,
        ascending: true,
        toOrderClauseArray: () => [Order.asc(OrderKeys.ownerName)]
      },
      'desc': {
        id: 'owner.desc',
        field: OrderKeys.ownerName,
        getMenuItemDisplayValue: Messages.sortByZA,
        getButtonDisplayValue: Messages.sortByOwnerDesc,
        ascending: false,
        toOrderClauseArray: () => [Order.desc(OrderKeys.ownerName)]
      }
    }
  },
  'modified': SortOptions.updated,
  'hits': SortOptions.hits,
};
